module.exports = __webpack_public_path__ + "static/media/gain.9357498e.png";